// extracted by mini-css-extract-plugin
module.exports = {"loadingSpinner":"ModalRequestCallback_loadingSpinner__niWsn","wrapper":"ModalRequestCallback_wrapper__0XhYc"};